import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../colorVars';
import { Dropdown } from '../../../../../atomic/atomicComponentLibrary/dropdown/Dropdown';
import { InputGroup } from '../../../../../atomic/atomicComponentLibrary/inputGroup/InputGroup';
import { NumericalInput } from '../../../../../atomic/atomicComponentLibrary/numericalInput/NumericalInput';
import { BoxSwitch } from '../../../../../atomic/atomicComponentLibrary/switches/boxSwitch/BoxSwitch';
import { BorderAndLabel } from '../../../../../atomic/atomicComponentLibrary/utility/borderAndLabel/BorderAndLabel';
import { Body4, fontSizes } from '../../../../../atomic/text/Text';
import style from './QuickTrade.module.css';

type Props = {
  margin?: string;
};

export const QuickTrade = observer(({ margin }: Props) => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();

  return (
    <BorderAndLabel
      backgroundColor="black"
      margin={margin}
      label="Trade"
      color="white"
      fontSize={fontSizes.body3}
    >
      <div className={style.container}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '5px',
          }}
        >
          <Body4 color={colors.lightGrey} margin="0 0 2px 0">
            Direction
          </Body4>
          <div className={style.directionCheckboxes}>
            <div className={style.labelAndCheckbox}>
              <input
                className={style.checkbox}
                type="checkbox"
                checked={tradePlanForm.goLong}
                onChange={({ target }) =>
                  tradePlanForm.setGoLong(target.checked)
                }
              />
              <Body4>Long</Body4>
            </div>
            <div className={style.labelAndCheckbox}>
              <input
                className={style.checkbox}
                type="checkbox"
                checked={tradePlanForm.goShort}
                onChange={({ target }) =>
                  tradePlanForm.setGoShort(target.checked)
                }
              />
              <Body4>Short</Body4>
            </div>
          </div>
        </div>
        <BoxSwitch
          margin="0 0 10px 5px"
          setValue={(value) => {
            tradePlanForm.setInstrument(value);
          }}
          notSelectedColor="grey"
          selectedColor="green"
          color="white"
          labels={['Equity', 'Option']}
          values={['stock', 'option']}
          controlledValue={tradePlanForm.instrument}
          title="Trade Type"
          fontSize={fontSizes.body4}
        />
        <Body4 color={colors.lightGrey} margin="0 0 2px 0">
          Quantity Basis
        </Body4>
        <InputGroup margin="0 0 5px 5px">
          <BoxSwitch
            margin="0 3px 0 0"
            setValue={tradePlanForm.setQuantityBasis}
            notSelectedColor="grey"
            selectedColor="green"
            color="white"
            labels={['$', '#']}
            values={['DOLLARS', 'QUANTITY']}
            controlledValue={tradePlanForm.quantityBasis}
            title="Quantity Basis"
            fontSize={fontSizes.body4}
          />
          <NumericalInput
            width="50px"
            maxHeight="23px"
            icon={tradePlanForm.quantityBasis === 'QUANTITY' ? '#' : '$'}
            onChange={tradePlanForm.setQuantityBasisValue}
            controlledValue={tradePlanForm.currentQuantityBasisValue}
            backgroundColor="grey"
            fontColor="white"
            fontSize={fontSizes.body4}
          />
        </InputGroup>
        <Body4 color={colors.lightGrey} margin="0 0 2px 0">
          Order Type
        </Body4>

        <InputGroup margin="0 0 5px 5px">
          <BoxSwitch
            margin="0 3px 0 0"
            setValue={tradePlanForm.setEntryTactic}
            notSelectedColor="grey"
            selectedColor="green"
            color="white"
            labels={['M', 'L']}
            values={['MARKET_ORDER', 'LIMIT_ORDER']}
            controlledValue={tradePlanForm.currentEntryTactic}
            title="Order Type"
            fontSize={fontSizes.body4}
          />
          <NumericalInput
            width="50px"
            disabled={tradePlanForm.currentEntryTactic === 'MARKET_ORDER'}
            maxHeight="23px"
            icon={'$'}
            onChange={tradePlanForm.entryTactics.LIMIT_ORDER?.setLimitPrice}
            controlledValue={
              tradePlanForm.entryTactics.LIMIT_ORDER?.limitPrice || 0
            }
            backgroundColor="grey"
            fontColor="white"
            fontSize={fontSizes.body4}
          />
        </InputGroup>
      </div>
    </BorderAndLabel>
  );
});

/**
 * Enter Long ✅
 * Enter Short ✅
 * Quantity Basis ✅
 * Quantity/Dollar Amt. ✅
 * Direction ✅
 * Display TP selected ✅
 * Limit Price ✅
 * Limit/Market(maybe just limit price, if one is not selected, its market) ✅
 *
 *
 */
